export default __webpack_public_path__ + "static/media/payable.34f56551.PNG";